/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ListTasksRead } from './listTasksRead';
import type { ListTasksStatus } from './listTasksStatus';

export type ListTasksParams = {
/**
 * Active project scope (required).
 */
project_id: string;
status?: ListTasksStatus;
read?: ListTasksRead;
types?: string[] | null;
priorities?: string[] | null;
jobs?: string[] | null;
jobs_excluded?: string[] | null;
sequences?: string[] | null;
sequences_excluded?: string[] | null;
candidates?: string[] | null;
candidates_excluded?: string[] | null;
assignees?: string[] | null;
assignees_excluded?: string[] | null;
due_from?: string | null;
due_to?: string | null;
q?: string | null;
cursor?: string | null;
/**
 * @minimum 1
 * @maximum 100
 */
per_page?: number;
sort?: string | null;
/**
 * Optional sub-scope to a single job within the project.
 */
job_id?: string | null;
/**
 * Optional sub-scope to a single sequence within the project.
 */
sequence_id?: string | null;
};
